import chickenAndChipsImage from './images/chicken-and-chips.svg';
import constants from '../../../../../../ahm-constants';

const {
  URLS: {
    SALES: { PRODUCT_LISTING_EXTRAS },
  },
} = constants;

const data = {
  tiles: [
    {
      cta: { isClickable: true, title: 'View extras cover', to: PRODUCT_LISTING_EXTRAS },
      image: {
        alt: '',
        src: chickenAndChipsImage.src,
      },
      summary: 'If nothing here tickles your fancy, check out our other cover options.',
      title: 'Want more extras?',
    },
  ],
};

export default data;
